import React from "react";
import { UserContextProvider } from "./src/components/context/UserContextContext";

export const wrapRootElement = ({ element }) => (
  <UserContextProvider>{element}</UserContextProvider>
);
